import { gql } from '@apollo/client';

export * from './migrateLegacyRepo.mutation.generated';

export const MIGRATE_LEGACY_REPO = gql`
  mutation migrateLegacyRepo($legacyRepoId: ID!, $integrationId: ID!, $oauthRepoId: ID) {
    migrateLegacyRepo(
      input: { legacyRepoId: $legacyRepoId, integrationId: $integrationId, oauthRepoId: $oauthRepoId }
    ) {
      success
      errors
    }
  }
`;
